"use strict";
HTMLElement.prototype.getWidth = function getWidth(type) {
    type = type !== null && type !== void 0 ? type : 'css';
    const compStyle = window.getComputedStyle(this);
    let width;
    switch (type) {
        case 'css':
            width = this.clientWidth;
            width -= parseInt(compStyle.paddingLeft || '0');
            width -= parseInt(compStyle.paddingRight || '0');
            return width;
        case 'inner':
            return this.clientWidth;
        case 'outer':
            return this.offsetWidth;
        case 'outer-margin':
            width = this.offsetWidth;
            width += parseInt(compStyle.marginLeft || '0');
            width += parseInt(compStyle.marginRight || '0');
            return width;
    }
    /* istanbul ignore next */
    return 0;
};
//# sourceMappingURL=GetWidth.js.map